import { Typography, Stack, Box, Chip, IconButton } from '@mui/material';
import TicketCard from './TicketCard';
import Iconify from '@/components/Iconify';
import { useTicketItemFacade } from './useTicketItemFacade';

// =============================================================================
// COMPONENTE PRINCIPAL: TicketItem
// =============================================================================

/**
 * Componente compound para mostrar un tipo de boleto.
 *
 * @param {Object} props
 * @param {Object}  props.ticket      - Datos del tipo de boleto
 * @param {Function} props.onChange    - Callback al cambiar cantidad
 * @param {boolean} props.withMap      - Si true, usa MapTicketItemUI
 */
export default function TicketSelectedItem({
  ticket,
  actionHandler,
  withMap,
  index,
}) {
  const {
    name,
    categoryColor,
    isSoldOut,
    price,
    hasDiscount,
    discountType,
    priceWithDiscount,
    bundleRule,
    leftTicketsToGetPromotion,
    outOfBundle,
    isFree,
    hasAdditionalFee,
    getVariant,
    deleteTicketHandler,
    getZone,
  } = useTicketItemFacade({
    withMap,
    ticket,
    onChange: () => { },
    applyBundle: true,
    index,
  });

  return (
    <TicketCard
      variant={getVariant(['default', 'promotion', 'fan2fan', 'soldOut'])}
      color={categoryColor}
    >
      <TicketCard.Body>
        <TicketCard.Info title={name}>
          <Typography
            sx={{
              fontSize: '12px',
              lineHeight: '130%',
              color: (theme) => theme.palette.text.disabled,
            }}
          >
            {getZone()}
          </Typography>
          {outOfBundle && (
            <Typography
              sx={{
                fontSize: '12px',
                lineHeight: '130%',
                color: (theme) => theme.palette.text.disabled,
              }}
            >
              <Typography
                component="span"
                sx={{
                  fontSize: '12px',
                  lineHeight: '130%',
                  color: '#139E65',
                }}
              >
                {bundleRule}
              </Typography>{' '}
              {`agregando ${leftTicketsToGetPromotion}  ${leftTicketsToGetPromotion > 1 ? 'boletos' : 'boleto'} más`}
            </Typography>
          )}
        </TicketCard.Info>

        <TicketCard.Action withPromotion={hasDiscount}>
          {isSoldOut ? (
            <TicketCard.SoldOut />
          ) : (
            <>
              <TicketCard.Price
                value={price}
                hasAdditionalFee={hasAdditionalFee}
                withMap={true}
                isFree={isFree}
                isSoldOut={isSoldOut}
                withPromotion={hasDiscount && !outOfBundle}
                discountType={
                  discountType === 'bundle' ? 'percentage' : discountType
                }
                priceWithDiscount={priceWithDiscount}
              />
              <IconButton size="small" onClick={deleteTicketHandler}>

                <Iconify icon="ph:trash-bold" fontSize={20} />
              </IconButton>
            </>
          )}
        </TicketCard.Action>
      </TicketCard.Body>
    </TicketCard>
  );
}
